import { render, staticRenderFns } from "./transfer-tab.vue?vue&type=template&id=54ad62ec&scoped=true&lang=pug&"
import script from "./transfer-tab.vue?vue&type=script&lang=js&"
export * from "./transfer-tab.vue?vue&type=script&lang=js&"
import style0 from "./transfer-tab.vue?vue&type=style&index=0&id=54ad62ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ad62ec",
  null
  
)

export default component.exports